import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { MessageCircle, CalendarCheck } from "lucide-react";
import { BUSINESS } from "../data/business";
import { track } from "../analytics";

export const CTABand = () => {
    return (
        <section data-testid="cta-band" className="relative bg-slate-900 overflow-hidden">
            <div className="absolute -top-24 left-1/4 w-[420px] h-[420px] rounded-full gold-glow opacity-70 animate-drift pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16 flex flex-col lg:flex-row lg:items-center gap-8">
                <div className="flex-1">
                    <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-white" data-testid="cta-band-title">
                        Fale agora com um contador
                    </h2>
                    <p className="mt-2 text-sm sm:text-base text-slate-300" data-testid="cta-band-subtitle">
                        Resposta rápida no WhatsApp ou diagnóstico gratuito pelo formulário.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 shrink-0">
                    <Button asChild size="lg" className="btn-shine rounded-lg bg-[#25D366] hover:bg-[#1fb857] text-white font-bold transition-transform duration-200 hover:-translate-y-1 shadow-sm hover:shadow-lg">
                        <a href={`${BUSINESS.whatsapp}?text=${encodeURIComponent("Olá! Quero falar com um contador da WBS.")}`} target="_blank" rel="noopener noreferrer" data-testid="cta-band-whatsapp" onClick={() => track("interaction", { label: "whatsapp", path: window.location.pathname })}>
                            <MessageCircle className="w-5 h-5 mr-2" />
                            Chamar no WhatsApp
                        </a>
                    </Button>
                    <Button asChild size="lg" variant="outline" className="rounded-lg border-slate-600 text-white font-bold hover:bg-white/10 hover:border-amber-500 hover:text-amber-400 transition-transform duration-200 hover:-translate-y-1">
                        <Link to="/contato" data-testid="cta-band-form" onClick={() => track("interaction", { label: "diagnosis", path: window.location.pathname })}>
                            <CalendarCheck className="w-5 h-5 mr-2" />
                            Diagnóstico gratuito
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};
